export const emailReg = /^\s*\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,16})+\s*$/;
export const lowercaseRegEx = /(?=.*[a-z])/;
export const uppercaseRegEx = /(?=.*[A-Z])/;
export const numericRegEx = /(?=.*[0-9])/;
export const passwordSpecialCharRegex = /^[^*|\":<>[\]{}`\\()';]+$/;
export const onlyAlphabateChar = /^[aA-zZ\s]+$/;
export const blankSpaceChar = /^(\S+$)/;
export const addressRegx = /^[A-Za-z0-9\!\@\#\$\%\^\&\*\"\|\\/\\?\\>\\ \\;,<'[`~{}?>:/\]\\)\(+\=\._-]+$/g;
export const designationRegex = /^^([\w\s-.]*)$/g;
export const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
export const special = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
export const LinkedinUrlRegex = /^(^((https?:\/\/)?((www|\w\w)\.)?)linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/;
export const organizationRegex = /^^([A-Za-z1-9\s-.()&]*)$/g;
export const socialLinkRegex = /^(https?:\/\/)?[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,3}(:[0-9]{1,5})?(\/.*)?$/;
export const GithubUrlRegex = /^([A-Za-z0-9]+@|http(|s)\:\/\/)([A-Za-z0-9.]+(:\d+)?)(?::|\/)([\d\/\w.-]+?)(\.git)?$/i;
export const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/i;
